import { languageCodesEqual } from "./languageCode";

/** The backend's name for an asset's original variant: what plays when no language matches. */
export const DEFAULT_VARIANT = "default";

/**
 * The variant to show for a language: its own variant, else the original ("default"), else the
 * first one. Mirrors the API's own pick (AssetService.GetAssets on the backend), so the editor
 * previews what the published training plays.
 */
export const resolveVariant = <T extends { variant: string | null }>(
  variants: T[] | undefined,
  languageCode: string | undefined
): T | undefined => {
  if (!variants || variants.length === 0) return undefined;
  return (
    variants.find((v) => languageCodesEqual(v.variant, languageCode)) ??
    variants.find((v) => v.variant === DEFAULT_VARIANT) ??
    variants[0]
  );
};
